/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiAggregateRoomMetricsForCompanyRequestFilterFromJSON, StreemApiAggregateRoomMetricsForCompanyRequestFilterToJSON, } from './';
export function StreemApiAggregateRoomMetricsForCompanyRequestFromJSON(json) {
    return StreemApiAggregateRoomMetricsForCompanyRequestFromJSONTyped(json, false);
}
export function StreemApiAggregateRoomMetricsForCompanyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'filter': !exists(json, 'filter') ? undefined : StreemApiAggregateRoomMetricsForCompanyRequestFilterFromJSON(json['filter']),
        'aggregateBy': !exists(json, 'aggregate_by') ? undefined : json['aggregate_by'],
        'pageSize': !exists(json, 'page_size') ? undefined : json['page_size'],
        'pageToken': !exists(json, 'page_token') ? undefined : json['page_token'],
    };
}
export function StreemApiAggregateRoomMetricsForCompanyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'filter': StreemApiAggregateRoomMetricsForCompanyRequestFilterToJSON(value.filter),
        'aggregate_by': value.aggregateBy,
        'page_size': value.pageSize,
        'page_token': value.pageToken,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy;
(function (StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy) {
    StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy["COMPANYSID"] = "AGGREGATE_BY_COMPANY_SID";
    StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy["GROUPNAME"] = "AGGREGATE_BY_GROUP_NAME";
    StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy["GROUPSID"] = "AGGREGATE_BY_GROUP_SID";
    StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy["USERSID"] = "AGGREGATE_BY_USER_SID";
})(StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy || (StreemApiAggregateRoomMetricsForCompanyRequestAggregateBy = {}));
//# sourceMappingURL=StreemApiAggregateRoomMetricsForCompanyRequest.js.map